import { useTranslation } from 'react-i18next';
import { LabelTypesEnum, PersonalInfoItems } from '~myAccount/enums';
import LayoutSkeleton from '~/components/LayoutSkeleton';
import PreviewCard from '~/components/PreviewCard';
import { useGetUserQuery } from '~/redux/api/userApiSlice';
import { LabelType } from '~/modules/myAccount/pages/PersonalInfo/types';
import { Link } from 'react-router-dom';
import { useFullRoutes } from '~/hooks';
import { Icon } from '@aqarmap/aqarmap-ui';
import { getPersonalInfoTitle } from '~myAccount/pages/PersonalInfo/utils/getPersonalInfo';

const PersonalInfo = () => {
  const { t, i18n } = useTranslation('app');
  const locale = i18n.language;
  const { MY_ACCOUNT_URL } = useFullRoutes();
  const { data: response, isLoading, isSuccess } = useGetUserQuery();
  const personalInfoIndex =
    Number(response?.user?.personal_info?.length) - 1 || 0;

  const age = response?.user.personal_info[personalInfoIndex]?.age;
  const gender = response?.user.personal_info[personalInfoIndex]?.gender;
  const maritalStatus =
    response?.user.personal_info[personalInfoIndex]?.marital_status;
  const education = response?.user.personal_info[personalInfoIndex]?.education;
  const industry = response?.user.personal_info[personalInfoIndex]?.industry;
  const position = response?.user.personal_info[personalInfoIndex]?.position;
  const purchasePurpose =
    response?.user.personal_info[personalInfoIndex]?.purchase_purpose;
  const purchaseFinancing =
    response?.user.personal_info[personalInfoIndex]?.purchase_financing;
  const purchaseTimeFrame =
    response?.user.personal_info[personalInfoIndex]?.purchase_timeframe;

  const sections: LabelType[] = [
    {
      title: t('age'),
      description: getPersonalInfoTitle(t, locale, PersonalInfoItems.AGE, age),
      labelType: LabelTypesEnum.PERSONAL_INFO,
    },
    {
      title: t('gender'),
      description: getPersonalInfoTitle(
        t,
        locale,
        PersonalInfoItems.GENDER,
        gender,
      ),
      labelType: LabelTypesEnum.PERSONAL_INFO,
    },
    {
      title: t('maritalStatus'),
      description: getPersonalInfoTitle(
        t,
        locale,
        PersonalInfoItems.MARITAL_STATUS,
        maritalStatus,
      ),
      labelType: LabelTypesEnum.PERSONAL_INFO,
    },
    {
      title: t('education'),
      description: getPersonalInfoTitle(
        t,
        locale,
        PersonalInfoItems.EDUCATION,
        education,
      ),
      labelType: LabelTypesEnum.PERSONAL_INFO,
    },
    {
      title: t('industry'),
      description: getPersonalInfoTitle(
        t,
        locale,
        PersonalInfoItems.INDUSTRY,
        industry,
      ),
      labelType: LabelTypesEnum.PERSONAL_INFO,
    },
    {
      title: t('position'),
      description: getPersonalInfoTitle(
        t,
        locale,
        PersonalInfoItems.POSITION,
        position,
      ),
      labelType: LabelTypesEnum.PERSONAL_INFO,
    },
    {
      title: t('purchaseTimeframe'),
      description: getPersonalInfoTitle(
        t,
        locale,
        PersonalInfoItems.PURCHASE_TIME_FRAME,
        purchaseTimeFrame,
      ),
      labelType: LabelTypesEnum.PERSONAL_INFO,
    },
    {
      title: t('purchasePurpose'),
      description: getPersonalInfoTitle(
        t,
        locale,
        PersonalInfoItems.PURCHASE_PURPOSE,
        purchasePurpose,
      ),
      labelType: LabelTypesEnum.PERSONAL_INFO,
    },
    {
      title: t('purchaseFinancing'),
      description: getPersonalInfoTitle(
        t,
        locale,
        PersonalInfoItems.PURCHASE_FINANCING,
        purchaseFinancing,
      ),
      labelType: LabelTypesEnum.PERSONAL_INFO,
    },
  ];

  return (
    <div className="flex flex-col gap-3x">
      <div className="flex justify-between">
        <p className="text-title_3 text-black">{t('personalInfo')}</p>
        <Link to={MY_ACCOUNT_URL.UPDATE_PERSONAL_INFO}>
          <Icon name="edit" className="text-blue" />
        </Link>
      </div>
      {isLoading && <LayoutSkeleton />}
      {!isLoading && isSuccess && (
        <div className="flex flex-col border border-gray rounded-[8px] py-3x">
          {sections.map((item, itemIndex) => (
            <PreviewCard key={`${item.title}-${itemIndex}`} {...item} />
          ))}
        </div>
      )}
    </div>
  );
};

export default PersonalInfo;
